'use client';

import { Banner } from './banner';
import { CustomerFirst } from './customer-first';
import { OurStory } from './our-story';
import { OurValues } from './our-values';
import { ReadyToShip } from './ready-to-ship';
import { WhyHisea } from './why-hisea';

export const AboutUsNewPage = () => {
  return (
    <div className='mx-auto w-full '>
      <Banner />

      <OurStory />

      <OurValues />

      <WhyHisea />

      <CustomerFirst />

      {/* <Partnerships /> */}

      <ReadyToShip />

      {/* <Footer /> */}
    </div>
  );
};
